<!--
 * @Description:批量分发
 * @Author: JDY
 * @Date: 2021-04-25 14:20:09
 * @LastEditTime: 2022-01-11 23:12:06
 * @LastEditors: Please set LastEditors
-->
<template>
  <a-form :form="form">

    <a-form-item label="选择试卷" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-spin :spinning="selectLoad">
        <a-select
          name="exam"
          showArrow
          allow-clear
          placeholder="请输入要搜索的试卷"
          v-decorator="[
            'exam',
            {
              rules: [{ required: true, message: '请选择试卷' }]
            }
          ]"
        >
          <a-select-option v-for="item in examList" :key="item.id.toString()">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-spin>
    </a-form-item>

  </a-form>
</template>

<script>

import { requestGet, requestPut } from '@/api/api'

export default {
    name: 'ModelForm',
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    data () {
        return {
            selectLoad: false, // 加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            examList: null,
            params: {},
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        this.getExamList() // 获取用户位列
    },
    methods: {
        /**
         * 获取用户下拉列表
         * @param
         * @jdy
         */
        getExamList () {
            const { params } = this
            requestGet('/exams/select', params)
                .then(res => {
                    this.examList = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
        },
        /**
         * 点击确定按钮提交表单
         * @param
         * @jdy
         */
        onOk () {
            const that = this
            const {
                form: { validateFields }
            } = that
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        requestPut('/courses/exam/' + that.$props.id, values)
                            .then(res => {
                                that.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        /**
         * 去掉按钮关闭弹窗
         * @param
         * @jdy
         */
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
